export async function handleMutateApiError(response: Response): Promise<never> {
  let errorMessage: string;

  try {
    const errorData = await response.json();
    errorMessage = `${response.status}: ${errorData.message}`;
  } catch (e) {
    // If JSON parsing fails, use a generic message
    errorMessage = `${response.status}: Something went wrong`;
  }

  throw new Error(errorMessage);
}
